import { CertificateEditorThemeProps } from "./CertificateEditor.types";
import { styles } from "./CertificateEditor.styles";
import { useCertificateStore } from "@/stores";
import { useCertificateEditor } from "./hooks/useCertificateEditor";

export const CertificateEditorTheme = ({ orientation }: CertificateEditorThemeProps) => {
  const { primaryColor, secondaryColor, thirdColor } = useCertificateStore();
  const { handleThemeColor } = useCertificateEditor();

  return (
    <div className="absolute inset-0">
      <div className={styles().inputControlPrimary({ orientation })}>
        <label
          className="cursor-pointer block relative before:border-3 before:content[''] before:block before:border-white before:border-opacity-50 before:rounded-full before:w-[160px] before:h-[160px] text-center"
          htmlFor="primaryColor"
        >
          <input
            className="opacity-0 h-full w-full rounded-full overflow-hidden invisible"
            id="primaryColor"
            type="color"
            value={primaryColor}
            onChange={e => handleThemeColor("primaryColor", e.target.value)}
          />
          <span className="bg-white uppercase bg-opacity-60 rounded-full inline-block min-w-[85px] p-2">
            {primaryColor}
          </span>
        </label>
      </div>

      <div className={styles().inputControlSecondary({ orientation })}>
        <label
          className="cursor-pointer block relative before:border-3 before:content[''] before:block before:border-white before:border-opacity-50 before:rounded-full before:w-[160px] before:h-[160px] text-center"
          htmlFor="secondaryColor"
        >
          <input
            className="opacity-0 h-full w-full rounded-full overflow-hidden invisible"
            id="secondaryColor"
            type="color"
            value={secondaryColor}
            onChange={e => handleThemeColor("secondaryColor", e.target.value)}
          />
          <span className="bg-white uppercase bg-opacity-60 rounded-full inline-block min-w-[85px] p-2">
            {secondaryColor}
          </span>
        </label>
      </div>

      <div className={styles().inputControlTertiary({ orientation })}>
        <label
          className="cursor-pointer block relative before:border-3 before:content[''] before:block before:border-white before:border-opacity-50 before:rounded-full before:w-[160px] before:h-[160px] text-center"
          htmlFor="thirdColor"
        >
          <input
            className="opacity-0 h-full w-full rounded-full overflow-hidden invisible"
            id="thirdColor"
            type="color"
            value={thirdColor}
            onChange={e => handleThemeColor("thirdColor", e.target.value)}
          />
          <span className="bg-white uppercase bg-opacity-60 rounded-full inline-block min-w-[85px] p-2">
            {thirdColor}
          </span>
        </label>
      </div>
    </div>
  );
};
